import React from 'react'

import { Formik } from 'formik'

import { Table, Button, Modal, Form } from '_zari/core'

import { ValidationSchema } from './validation'

import * as Cells from './cells'

const MainRow = ({ row, dispatch, autoFocus }) => {
  const [showModal, setShowModal] = React.useState(false)
  const [obsTemp, setObsTemp] = React.useState(row.observacion || '')

  const formInitialValues = React.useMemo(() => {
    return {
      cantidad: row.cantidad ?? '',
      fechaRequerimiento: row.fechaRequerimiento ?? ''
    }
  }, [row])

  const handleGuardarObs = () => {
    dispatch({
      type: 'actualizar',
      payload: { _idFila: row._idFila, observacion: obsTemp }
    })
    setShowModal(false)
  }

  return (
    <>
      <Formik initialValues={formInitialValues} validationSchema={ValidationSchema} enableReinitialize>
        {({ errors, touched, handleChange }) => (
          <Table.Row>
            <Table.Cell>{row.codigoProducto ?? '--'}</Table.Cell>
            <Table.Cell>{row.nombreProducto ?? '--'}</Table.Cell>
            <Table.Cell>{row.unidadMedida ?? '--'}</Table.Cell>
            <Cells.CantidadCell
              row={row}
              dispatch={dispatch}
              iError={errors.cantidad}
              iTouched={touched.cantidad}
              handleChange={handleChange}
              autoFocus={autoFocus}
            />
            <Cells.FechaRequerimientoCell
              row={row}
              dispatch={dispatch}
              iError={errors.fechaRequerimiento}
              iTouched={touched.fechaRequerimiento}
              handleChange={handleChange}
            />
            <Table.Cell style={{ textAlign: 'center' }}>
              <Button
                variant={row.observacion ? 'success' : 'outline-secondary'}
                size='sm'
                onClick={() => setShowModal(true)}
                title={row.observacion || 'Agregar observación'}
              >
                +
              </Button>
            </Table.Cell>
            <Cells.EliminarCell row={row} dispatch={dispatch} />
          </Table.Row>
        )}
      </Formik>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header>
          <Modal.Title>Observación - {row.nombreProducto}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <textarea
            className='form-control'
            value={obsTemp}
            onChange={e => setObsTemp(e.target.value)}
            rows={3}
            placeholder='Ingrese observación del ítem'
          />
        </Modal.Body>
        <Modal.Footer>
          <Button color='secondary' onClick={() => setShowModal(false)}>
            Cancelar
          </Button>
          <Button onClick={handleGuardarObs}>Guardar</Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default React.memo(MainRow)
